import { Injectable } from '@angular/core';
import {FilterDto, ResourceListDto} from '../../../models/server/index-objects';
import { PageableService } from '../base/pageable.service';
import { HttpTechLocationApiService } from '../http/http-location-api/http-location-api.service';
import { HttpApiService } from '../http/http-api.service';
import { SortingParams } from '../../../models/client/api/sorting-params';
import { HttpParams } from '@angular/common/http';
import {map} from 'rxjs/operators';
import {MessageIssuePreviewDto} from '../issue/message-issue-template.service';
import { Page } from 'models/client';


const PAGESIZE = 50;


export class ResourcePageService extends PageableService<ResourceListDto>{
    constructor(
        protected http: HttpApiService,
        protected endpoint: string,
        protected pageSize?: number
    ) {
        super(http, endpoint, pageSize);
    }

    protected createHttpParams(pageNumber: number = null, pageSize: number = null, sortingParams: SortingParams = null): HttpParams {
        return super
            .createHttpParams(pageNumber, pageSize, sortingParams)
            .set('cols', 'hasChildren');
    }
}

@Injectable({
    providedIn: 'root'
})
export class ResourceService {
    constructor(
        protected http: HttpTechLocationApiService
    ) { }

    getDatatableItems(viewId: number): Promise<ResourceListDto[]> {
        return this.http
            .post<Page<ResourceListDto>>(
                `resource/filter?PageSize=250&ViewId=${viewId}`,
                [
                    <FilterDto> {
                        property: 'isArchived',
                        value: 'false'
                    },
                    <FilterDto> {
                        property: 'currentState',
                        value: '1'
                    }
                ]
            )
            .pipe(map(x => x.body.items))
            .toPromise();
    }

    createService(): ResourcePageService {
        return new ResourcePageService(this.http, 'location/me/resource', PAGESIZE);
    }

    createRootService(): ResourcePageService {
        return new ResourcePageService(this.http, 'location/me/resource/root', PAGESIZE);
    }

    createChildService(parentId: number): ResourcePageService {
        return new ResourcePageService(this.http, `resource/${parentId}/children`, PAGESIZE);
    }
}
